import { motion } from 'framer-motion';

const Animation = ({ children }) => {
    const variants = {
        hidden: { opacity: 0, y: 100 },
        visible: { opacity: 1, y: 0 },
        exit: { opacity: 0, y: -100 },
    };

    return (
        <motion.div
            initial="hidden"
            whileInView="visible"
            exit="exit"
            transition={{
                duration: 1,
                ease: "easeOut",
            }}
            variants={variants}
            viewport={{ once: false, amount: 0.1 }}
        >
            {children}
        </motion.div>
    );
};

export default Animation;
